var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 104,
    viewBox: "0 0 103 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5996 9.39804V10.898C15.5996 13.0115 14.5144 15.2615 12.8631 16.5805C10.5692 18.4129 9.09961 21.2338 9.09961 24.398V84.398C9.09961 89.9209 13.5768 94.398 19.0996 94.398H92.0996C97.6225 94.398 102.1 89.9209 102.1 84.398V24.398C102.1 18.8752 97.6225 14.398 92.0996 14.398H89.8604C87.1913 14.398 85.0883 12.0027 83.1434 10.1747C82.2628 9.34696 81.1352 8.77059 79.867 8.56985L26.4644 0.117642C20.7603 -0.785153 15.5996 3.62302 15.5996 9.39804Z",
    fill: "#9CC3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.1 66.2981C64.1 68.6981 65 70.7981 66.5 72.2981C66.8 72.5981 67.1 72.8981 67.4 72.8981C68.9 74.0981 70.7 74.6981 72.8 74.6981H88.1V88.1981C88.1 95.3981 82.4 101.098 75.2 101.098H14.9C7.7 101.098 2 95.3981 2 88.1981V44.0981C2 43.7981 2 43.1981 2 42.8981C2.6 37.7981 6.2 33.2981 11 31.7981C12.2 31.4981 13.7 31.1981 14.9 31.1981H75.2C76.4 31.1981 77.9 31.4981 79.1 31.7981C83.9 33.2981 87.8 37.7981 88.1 42.8981C88.1 43.1981 88.1 43.7981 88.1 44.0981V57.5981H72.5C70.4 57.5981 68.6 58.1981 67.1 59.3981C65.3 61.1981 64.1 63.5981 64.1 66.2981Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.5996 74.998H79.0996V79.498",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M77.9 88.1981C76.4 91.7981 72.8 94.1981 68.6 94.1981H21.2C15.5 94.1981 11 89.6981 11 83.9981V48.8981C11 43.1981 15.5 38.6981 21.2 38.6981H68.9C74.6 38.6981 79.1 43.1981 79.1 48.8981",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M79.0996 53.3981V57.8981H74.5996",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M65.5996 61.498C64.6996 62.998 64.0996 64.498 64.0996 66.298C64.0996 68.698 64.9996 70.798 66.4996 72.298C66.7996 72.598 67.0996 72.898 67.3996 72.898C67.9996 73.498 68.8996 73.798 69.4996 74.098",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.42 3.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M90.2008 57.8981V74.9981H72.5008C70.4008 74.9981 68.6008 74.3981 67.1008 73.1981C66.8008 72.8981 66.5008 72.5981 66.2008 72.5981C64.7008 71.0981 63.8008 68.9981 63.8008 66.5981C63.8008 63.8981 65.0008 61.4981 67.1008 59.6981C68.6008 58.4981 70.4008 57.8981 72.5008 57.8981H90.2008Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M73.0996 66.2981H81.1996",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M38.3008 62.6981C38.9008 64.7981 40.7008 66.2981 42.8008 66.2981C43.4008 66.2981 45.2008 65.6981 45.2008 66.2981",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M51.7992 71.098V70.798C51.7992 68.098 49.6992 66.298 47.2992 66.298C47.2992 66.298 45.1992 65.698 45.1992 66.298",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M38.3008 62.698C38.3008 62.398 38.3008 62.098 38.3008 61.498C38.3008 59.098 40.4008 56.998 42.8008 56.998H46.1008H46.4008H51.8008",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M38.3008 75.298H46.1008H47.3008C49.7008 75.298 51.8008 73.498 51.8008 71.098",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M46.0996 51.8981V56.9981",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M46.0996 75.598V80.698",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M22.4 20.998L21.8 31.198H14.9C13.4 31.198 12.2 31.498 11 31.798C6.2 33.298 2.6 37.798 2 42.898V30.898C2 26.398 5.3 22.198 9.5 21.298C10.1 20.998 11 20.998 11.9 20.998H22.4Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M88.1004 30.8981V42.8981C87.8004 37.7981 83.9004 33.2981 79.1004 31.7981C77.9004 31.4981 76.4004 31.1981 75.2004 31.1981H68.9004L69.5004 21.2981H79.4004C84.5004 21.8981 88.1004 25.7981 88.1004 30.8981Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M69.8008 16.7981L68.9008 31.1981H21.8008L23.0008 13.4981C23.3008 12.2981 24.2008 11.3981 25.7008 11.3981L67.7008 14.3981C68.9008 14.6981 69.8008 15.5981 69.8008 16.7981Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyWallet);
export default __webpack_public_path__ + "static/media/MoneyWallet.ebf6db023b8ba915e7072edd04250acb.svg";
export { ForwardRef as ReactComponent };